import BarclaysLogo from 'assets/svgs/banks/barclays.svg';
import HSBCLogo from 'assets/svgs/banks/hsbc.svg';
import LloydsLogo from 'assets/svgs/banks/lloyds.svg';
import RBSLogo from 'assets/svgs/banks/rbs.svg';
import NationwideLogo from 'assets/svgs/banks/nationwide.svg';
import SantanderLogo from 'assets/svgs/banks/santander.svg';
import DefaultBankLogo from 'assets/svgs/banks/default.svg';
import TideLogo from 'assets/svgs/banks/tide.svg';
import StarlingLogo from 'assets/svgs/banks/starling.svg';
import MettleLogo from 'assets/svgs/banks/mettle.svg';
import RevolutLogo from 'assets/svgs/banks/revolut.svg';
import MonzoLogo from 'assets/svgs/banks/monzo.svg';
import CoconutLogo from 'assets/svgs/banks/coconut.svg';

import { formatCurrency } from 'utils/NumberHelper';

export const Banks = Object.freeze({
  barclays: 'Barclays',
  hsbc: 'HSBC',
  rbs: 'RBS',
  nationwide: 'Nationwide',
  lloyds: 'Lloyds Bank',
  santander: 'Santander',
  tide: 'Tide',
  starling: 'Starling',
  mettle: 'Mettle',
  revolut: 'Revolut',
  monzo: 'Monzo',
  coconut: 'Coconut',
  other: 'Other',
});

const BankIcons = Object.freeze({
  [Banks.barclays]: BarclaysLogo,
  [Banks.hsbc]: HSBCLogo,
  [Banks.lloyds]: LloydsLogo,
  [Banks.rbs]: RBSLogo,
  [Banks.santander]: SantanderLogo,
  [Banks.nationwide]: NationwideLogo,
  [Banks.tide]: TideLogo,
  [Banks.starling]: StarlingLogo,
  [Banks.mettle]: MettleLogo,
  [Banks.revolut]: RevolutLogo,
  [Banks.monzo]: MonzoLogo,
  [Banks.coconut]: CoconutLogo,
});

// TODO: remove stubbed BankRates and relay on BE response only M-361
const BankRates = Object.freeze({
  [Banks.barclays]: [
    { min: 1000, max: 5000, ear: 13.56 },
    { min: 5001, max: 10000, ear: 12.25 },
    { min: 10001, max: 15000, ear: 12.05 },
    { min: 15001, max: 20000, ear: 10.03 },
    { min: 20001, max: 25000, ear: 10.03 },
  ],
  [Banks.lloyds]: [
    { min: 1000, max: 5000, ear: 11.02 },
    { min: 5001, max: 10000, ear: 11.02 },
    { min: 10001, max: 15000, ear: 11.02 },
    { min: 15001, max: 20000, ear: 11.02 },
    { min: 20001, max: 25000, ear: 11.02 },
  ],
  [Banks.hsbc]: [
    { min: 1000, max: 5000, ear: 9.9 },
    { min: 5001, max: 10000, ear: 9.9 },
    { min: 10001, max: 15000, ear: 9.9 },
    { min: 15001, max: 20000, ear: 9.9 },
    { min: 20001, max: 25000, ear: 9.9 },
  ],
  [Banks.rbs]: [
    { min: 1000, max: 5000, ear: 6.4 },
    { min: 5001, max: 10000, ear: 5.88 },
    { min: 10001, max: 15000, ear: 5.88 },
    { min: 15001, max: 20000, ear: 5.88 },
    { min: 20001, max: 25000, ear: 5.88 },
  ],
  [Banks.santander]: [
    { min: 1000, max: 5000, ear: 6.75 },
    { min: 5001, max: 10000, ear: 6.75 },
    { min: 10001, max: 15000, ear: 6.75 },
    { min: 15001, max: 20000, ear: 6.75 },
    { min: 20001, max: 25000, ear: 6.75 },
  ],
});

export const BankUnarrangedCharge = Object.freeze({
  [Banks.barclays]: 29.5,
  [Banks.hsbc]: 21.34,
  [Banks.rbs]: 15,
  [Banks.santander]: 25.75,
});

export const Products = Object.freeze({
  overdraft: 'overdraft',
  noOverdraft: 'noOverdraft',
  mortgage: 'mortgage',
});

export const ProductsTitle = Object.freeze({
  [Products.overdraft]: 'Overdraft',
  [Products.noOverdraft]: 'No Overdraft',
  [Products.mortgage]: 'Mortgage',
});

export const MappingProductsTitle = Object.freeze({
  [Products.overdraft]: 'With Overdraft',
  [Products.noOverdraft]: 'Without Overdraft',
  [Products.mortgage]: 'Mortgage',
});

export const productsToDropdown = () =>
  Object.keys(Products).map((productKey) => ({
    value: productKey,
    label: MappingProductsTitle[productKey],
  }));

export const getBankIcon = (name) => BankIcons[name] || DefaultBankLogo;

export const getEstimatedEarRate = (name = 'HSBC') => {
  const rates = BankRates[name];

  if (rates && rates.length) {
    const min = Math.min(...rates.map((rate) => rate.ear));
    const max = Math.min(...rates.map((rate) => rate.ear));
    return min === max
      ? `${formatCurrency(min / 100, '0.00%')}`
      : `${formatCurrency(min / 100, '0.00%')} - ${formatCurrency(max / 100, '0.00%')}`;
  }

  return '0.00%';
};
